import { getElementById } from '@dni-utils/get-element-by-id'
import { scrollTo } from '@utils'
import { CART_LIST_SCROLLER_ID } from '../components/CartListScroller/CartListScroller'
import { focusCartListItem } from './focusCartListItem'
import { resetAllFocusStyle } from './resetAllFocusStyle'
import { resetCartListItem } from './resetCartListItem'

const updateFocusStyleByObserver = (target: HTMLElement, container: HTMLElement, onFocus: (target: HTMLElement) => void) => {
  if (!target || !container) return
  const observer = new IntersectionObserver((entries) => {
    if (!entries[0]?.isIntersecting) return
    setTimeout(() => {
      onFocus?.(target)
    }, 200)
    observer.disconnect()
  }, {
    root: container,
    threshold: 0.9,
  })
  observer.observe(target)
}
export const scrollToCartListItem = (itemIndex: number) => {
  const container = getElementById(CART_LIST_SCROLLER_ID)
  const listElement = container?.querySelector<HTMLElement>(`[data-index="${itemIndex}"]`)
  if (container && listElement) {
    resetAllFocusStyle(container, resetCartListItem)
    updateFocusStyleByObserver(
      listElement,
      container,
      focusCartListItem,
    )
    scrollTo({
      top: listElement.offsetTop,
    }, container)
  }
}
